// extracted by mini-css-extract-plugin
module.exports = {"form":"Register_form__2x4la","registerBtn":"Register_registerBtn__2yrdr","textField":"Register_textField__27rej","rowContainer":"Register_rowContainer__3JCF6"};